import { FileInfo } from '../../../model/shared/user/user';

export class FileLoader {
    dataURItoBlob(dataURI) {
        // convert base64 to raw binary data held in a string
        const byteString = atob(dataURI.split(',')[1]);

        // separate out the mime component
        const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

        // write the bytes of the string to an ArrayBuffer
        const arrayBuffer = new ArrayBuffer(byteString.length);
        const _ia = new Uint8Array(arrayBuffer);
        for (let i = 0; i < byteString.length; i++) {
            _ia[i] = byteString.charCodeAt(i);
        }

        const dataView = new DataView(arrayBuffer);
        const blob = new Blob([dataView], { type: mimeString });
        return blob;
    }

    fileDownload(sys_idx: number, idx: number, list: Array<FileInfo>) {
        let files;
        let doc;
        if (sys_idx) {
            files = list.filter(data => data.idx === sys_idx);
            doc = files[0];
        } else {
            doc = list[idx];
        }

        const blob = this.dataURItoBlob(doc.data);

        const a = document.createElement('a');
        document.body.appendChild(a);
        a.style['display'] = 'none';
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = doc.name;
        a.click();
        window.URL.revokeObjectURL(url);
    }

    getDataByIdxFromList(idx: number, list: Array<FileInfo>) {
        let data;
        const fi = list.filter(file => file.idx == idx);
        if (fi === undefined || fi.length === 0) {
            data = list[idx];
        } else {
            data = fi[0];
        }
        const fIdx = list.indexOf(data, 0);
        const obj = list[fIdx];
        return obj.data;
    }

    getRidFromList(sys_idx: number, idx: number, list: Array<FileInfo>) {
        if (!list) {
            return;
        }
        let data;
        let file;
        if (sys_idx) {
            file = list.filter(fi => fi.idx === sys_idx);
            data = file[0];
        } else {
            data = list[idx];
        }
        const fIdx = list.indexOf(data, 0);
        if (fIdx > -1) {
            list.splice(fIdx, 1);
        }
    }

    fileLoad(file: File, filelist: Array<FileInfo>) {
        const filereader: FileReader = new FileReader();
        filereader.onloadend = (e) => {
            if (filereader.result) {
                const newFile = new FileInfo();
                newFile.data = filereader.result.toString();
                newFile.type = file.type;
                if (!newFile.type) {
                    newFile.type = 'application/octet-stream';
                }
                newFile.name = file.name;
                newFile.updateYn = true;
                filelist.push(newFile);
            }
        }
        filereader.readAsDataURL(file);
    }
};



// WEBPACK FOOTER //
// ./src/app/shared/component/fileloader/fileloader.ts